import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "cdn-upload-page" };
const _hoisted_2 = { class: "upload-section" };
const _hoisted_3 = { class: "upload-header" };
const _hoisted_4 = {
    key: 0,
    class: "upload-content"
};
const _hoisted_5 = { class: "alert-message" };
const _hoisted_6 = {
    key: 0,
    class: "upload-queue"
};
const _hoisted_7 = { class: "upload-item-header" };
const _hoisted_8 = { class: "file-info" };
const _hoisted_9 = { class: "file-icon" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "file-details" };
const _hoisted_13 = { class: "file-name" };
const _hoisted_14 = { class: "file-size" };
const _hoisted_15 = { class: "upload-status" };
const _hoisted_16 = {
    key: 0,
    class: "spinner"
};
const _hoisted_17 = {
    key: 1,
    class: "status-icon success"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    key: 0,
    class: "progress-bar"
};
const _hoisted_20 = { class: "progress-text" };
const _hoisted_21 = { class: "upload-actions" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = { class: "file-list-section" };
const _hoisted_24 = { class: "search-box" };
const _hoisted_25 = {
    key: 0,
    class: "loading"
};
const _hoisted_26 = {
    key: 1,
    class: "file-grid"
};
const _hoisted_27 = { class: "file-preview" };
const _hoisted_28 = ["src", "alt"];
const _hoisted_29 = ["src"];
const _hoisted_30 = {
    key: 2,
    class: "file-icon-large"
};
const _hoisted_31 = { class: "file-card-info" };
const _hoisted_32 = ["title"];
const _hoisted_33 = { class: "file-card-date" };
const _hoisted_34 = { class: "file-card-actions" };
const _hoisted_35 = ["href"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_38 = { class: "modal-body" };
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CDNUploadPage',
    setup(__props) {
        const admin = useAdmin();
        const files = ref([]);
        const uploadQueue = ref([]);
        const searchQuery = ref('');
        const isUploadExpanded = ref(false);
        const isDragging = ref(false);
        const isUploading = ref(false);
        const loading = ref(false);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const fileToDelete = ref(null);
        const supportedTypes = ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.mp4', '.pdf', '.html'];
        const fileInput = ref(null);
        const filteredFiles = computed(() => {
            if (!files.value)
                return [];
            const query = searchQuery.value.toLowerCase();
            return files.value.filter((f) => f.fileName.toLowerCase().includes(query) &&
                supportedTypes.some(type => f.fileName.toLowerCase().endsWith(type)));
        });
        function triggerFileInput() {
            fileInput.value.click();
        }
        function onFilesSelected(event) {
            const selectedFiles = Array.from(event.target.files);
            addFilesToQueue(selectedFiles);
            event.target.value = '';
        }
        function onDrop(event) {
            isDragging.value = false;
            const droppedFiles = Array.from(event.dataTransfer.files);
            addFilesToQueue(droppedFiles);
        }
        function generateGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = (Math.random() * 16) | 0;
                const v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
        function addFilesToQueue(newFiles) {
            newFiles.forEach((file) => {
                const fileType = '.' + file.name.split('.').pop().toLowerCase();
                if (!supportedTypes.includes(fileType)) {
                    showMessage(`File type ${fileType} is not supported`, 'error');
                    return;
                }
                let preview = null;
                if (file.type.startsWith('image/')) {
                    preview = URL.createObjectURL(file);
                }
                const CHUNK_SIZE = 1024 * 1024; // 1MB
                const chunkCount = Math.ceil(file.size / CHUNK_SIZE);
                uploadQueue.value.push({
                    file,
                    name: file.name,
                    size: file.size,
                    preview,
                    status: 'pending',
                    progress: 0,
                    chunkCount,
                    currentChunk: 0,
                    uploadId: generateGuid()
                });
            });
            if (!isUploading.value) {
                processUploadQueue();
            }
        }
        async function processUploadQueue() {
            isUploading.value = true;
            for (const item of uploadQueue.value) {
                if (item.status === 'pending' || item.status === 'error') {
                    item.status = 'uploading';
                    item.progress = 0;
                    item.currentChunk = 0;
                    try {
                        await uploadFileInChunks(item);
                        item.status = 'success';
                        item.progress = 100;
                    }
                    catch (error) {
                        console.error('Upload error:', error);
                        item.status = 'error';
                        showMessage(`Failed to upload ${item.name}`, 'error');
                    }
                }
            }
            setTimeout(() => {
                uploadQueue.value = uploadQueue.value.filter(item => item.status !== 'success');
                isUploading.value = false;
                if (uploadQueue.value.some(item => item.status === 'pending')) {
                    processUploadQueue();
                }
            }, 2000);
            refreshFileList();
        }
        async function uploadFileInChunks(item) {
            const CHUNK_SIZE = 1024 * 1024; // 1MB
            const totalChunks = item.chunkCount;
            for (let i = 0; i < totalChunks; i++) {
                const start = i * CHUNK_SIZE;
                const end = Math.min(item.size, start + CHUNK_SIZE);
                const chunk = item.file.slice(start, end);
                const base64 = await getBase64(chunk);
                await new Promise((resolve, reject) => {
                    admin.uploadFileChunk(base64, item.name, i, totalChunks, item.uploadId, () => resolve(), (error) => reject(new Error(error)));
                });
                item.currentChunk = i;
                item.progress = Math.round(((i + 1) / totalChunks) * 100);
            }
        }
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }
        function retryUpload(item) {
            item.status = 'pending';
            if (!isUploading.value) {
                processUploadQueue();
            }
        }
        function refreshFileList() {
            loading.value = true;
            admin.getFiles((filesData) => {
                files.value = filesData || [];
                loading.value = false;
            }, (error) => {
                showMessage(error, 'error');
                loading.value = false;
            });
        }
        function deleteFile(file) {
            fileToDelete.value = file;
        }
        function cancelDelete() {
            fileToDelete.value = null;
        }
        function confirmDelete() {
            if (!fileToDelete.value)
                return;
            admin.deleteFile(fileToDelete.value.fileName, () => {
                showMessage(`File "${fileToDelete.value.fileName}" deleted successfully`);
                fileToDelete.value = null;
                refreshFileList();
            }, (error) => {
                showMessage(error, 'error');
                fileToDelete.value = null;
            });
        }
        function isImageFile(fileName) {
            const ext = fileName.toLowerCase().split('.').pop();
            return ['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(ext);
        }
        function isVideoFile(fileName) {
            return fileName.toLowerCase().endsWith('.mp4');
        }
        function formatFileSize(bytes) {
            if (bytes === 0)
                return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
        function formatDate(dateString) {
            if (!dateString)
                return '-';
            const date = new Date(dateString);
            return date.toLocaleString('en-GB');
        }
        function handleImageError(event) {
            event.target.style.display = 'none';
        }
        function showMessage(message, variant = 'success') {
            alertMessage.value = message;
            alertVariant.value = variant;
            showAlert.value = true;
            if (variant !== 'error') {
                setTimeout(() => {
                    showAlert.value = false;
                }, 5000);
            }
        }
        onMounted(() => {
            refreshFileList();
        });
        onBeforeUnmount(() => {
            uploadQueue.value.forEach((item) => {
                if (item.preview) {
                    URL.revokeObjectURL(item.preview);
                }
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "CDN - File Upload"),
                    _createElementVNode("p", { class: "subtitle" }, "Upload and manage content files")
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                            class: "collapse-btn",
                            onClick: _cache[0] || (_cache[0] = ($event) => (isUploadExpanded.value = !isUploadExpanded.value))
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["collapse-icon", { rotated: isUploadExpanded.value }])
                            }, "›", 2),
                            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Upload Files", -1))
                        ])
                    ]),
                    _createVNode(_Transition, { name: "collapse-transition" }, {
                        default: _withCtx(() => [
                            (isUploadExpanded.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["upload-area", { dragging: isDragging.value }]),
                                        onDragover: _cache[1] || (_cache[1] = _withModifiers(($event) => (isDragging.value = true), ["prevent"])),
                                        onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event) => (isDragging.value = false), ["prevent"])),
                                        onDrop: _withModifiers(onDrop, ["prevent"])
                                    }, [
                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "upload-icon" }, "📤", -1)),
                                        _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Drag & Drop Files Here", -1)),
                                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "upload-subtitle" }, "or", -1)),
                                        _createElementVNode("button", {
                                            class: "action-btn primary",
                                            onClick: triggerFileInput
                                        }, " Select Files "),
                                        _createElementVNode("input", {
                                            ref_key: "fileInput",
                                            ref: fileInput,
                                            type: "file",
                                            multiple: "",
                                            accept: "image/*,video/*,.pdf,.html",
                                            onChange: onFilesSelected,
                                            class: "file-input"
                                        }, null, 544),
                                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "supported-formats" }, " Supported: JPG, PNG, GIF, SVG, MP4, PDF, HTML ", -1))
                                    ], 34),
                                    _createVNode(_Transition, { name: "fade" }, {
                                        default: _withCtx(() => [
                                            (showAlert.value)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                                                }, [
                                                    _createElementVNode("span", _hoisted_5, _toDisplayString(alertMessage.value), 1),
                                                    _createElementVNode("button", {
                                                        class: "alert-close",
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (showAlert.value = false))
                                                    }, "✕")
                                                ], 2))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    (uploadQueue.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Upload Queue", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadQueue.value, (file, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: index,
                                                    class: _normalizeClass(["upload-item", file.status])
                                                }, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createElementVNode("div", _hoisted_8, [
                                                            _createElementVNode("div", _hoisted_9, [
                                                                (isImageFile(file.name))
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                        (file.preview)
                                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                                key: 0,
                                                                                src: file.preview,
                                                                                alt: file.name
                                                                            }, null, 8, _hoisted_10))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_11, "🖼️"))
                                                                    ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createTextVNode(" 📄 ")
                                                                    ], 64))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_12, [
                                                                _createElementVNode("div", _hoisted_13, _toDisplayString(file.name), 1),
                                                                _createElementVNode("div", _hoisted_14, _toDisplayString(formatFileSize(file.size)), 1)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_15, [
                                                            (file.status === 'uploading')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                                                : (file.status === 'success')
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "✓"))
                                                                    : (file.status === 'error')
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "status-icon error" }, "✕", -1)),
                                                                            _createElementVNode("button", {
                                                                                class: "retry-btn",
                                                                                onClick: ($event) => (retryUpload(file))
                                                                            }, "Retry", 8, _hoisted_18)
                                                                        ], 64))
                                                                        : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    (file.status === 'uploading')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                            _createElementVNode("div", {
                                                                class: "progress",
                                                                style: _normalizeStyle({ width: file.progress + '%' })
                                                            }, null, 4),
                                                            _createElementVNode("span", _hoisted_20, _toDisplayString(file.progress) + "%", 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ], 2));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: refreshFileList,
                                            disabled: isUploading.value
                                        }, " 🔄 Refresh List ", 8, _hoisted_22)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((searchQuery).value = $event)),
                            type: "text",
                            placeholder: "Search files...",
                            class: "search-input"
                        }, null, 512), [
                            [_vModelText, searchQuery.value]
                        ])
                    ]),
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[13] || (_cache[13] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1),
                            _createElementVNode("p", null, "Loading files...", -1)
                        ])))
                        : (filteredFiles.value && filteredFiles.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFiles.value, (file) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: file.fileName,
                                        class: "file-card"
                                    }, [
                                        _createElementVNode("div", _hoisted_27, [
                                            (isImageFile(file.fileName))
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: file.uri,
                                                    alt: file.fileName,
                                                    onError: handleImageError
                                                }, null, 40, _hoisted_28))
                                                : (isVideoFile(file.fileName))
                                                    ? (_openBlock(), _createElementBlock("video", {
                                                        key: 1,
                                                        src: file.uri,
                                                        muted: "",
                                                        preload: "metadata"
                                                    }, null, 8, _hoisted_29))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, "📄"))
                                        ]),
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("div", {
                                                class: "file-card-name",
                                                title: file.fileName
                                            }, _toDisplayString(file.fileName), 9, _hoisted_32),
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(formatDate(file.lastModifiedDateTime)), 1),
                                            _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("a", {
                                                    href: file.uri,
                                                    target: "_blank",
                                                    class: "action-link view-link",
                                                    title: "Open file"
                                                }, " 🔗 ", 8, _hoisted_35),
                                                _createElementVNode("button", {
                                                    class: "action-link delete-link",
                                                    onClick: ($event) => (deleteFile(file)),
                                                    title: "Delete file"
                                                }, " 🗑️ ", 8, _hoisted_36)
                                            ])
                                        ])
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_37, " No files found "))
                ]),
                (fileToDelete.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: cancelDelete
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", { class: "modal-header" }, [
                                _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Delete File", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: cancelDelete
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("p", null, [
                                    _cache[15] || (_cache[15] = _createTextVNode("Are you sure you want to delete ")),
                                    _createElementVNode("strong", null, _toDisplayString(fileToDelete.value.fileName), 1),
                                    _cache[16] || (_cache[16] = _createTextVNode("?"))
                                ]),
                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "warning-text" }, "⚠️ This action cannot be undone.", -1))
                            ]),
                            _createElementVNode("div", { class: "modal-actions" }, [
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: cancelDelete
                                }, "Cancel"),
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: confirmDelete
                                }, "Delete")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
